"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const qs_1 = require("qs");
const queryParse = (query) => (0, qs_1.parse)(query, {
    ignoreQueryPrefix: true,
    interpretNumericEntities: false,
    strictNullHandling: true,
    plainObjects: true,
    arrayLimit: 100,
});
exports.default = queryParse;
